<script>
// Extensions
import View from '@/views/View';

// Mixins
import LoadSections from '@/mixins/load-sections';

export default {
  name: 'Products and Services',

  metaInfo: { title: 'About Us' },

  extends: View,

  mixins: [
    LoadSections([
      'hero-alt',
      'about-our-products-and-services',
      'we-work-on',
      'contact-us',
      'info',
    ]),
  ],

  props: {
    id: {
      type: String,
      default: 'about',
    },
  },
};
</script>
